// extracted by mini-css-extract-plugin
export default {"widget-styles":"WHwzVi","widgetStyles":"WHwzVi"};